/**
 * Default per-course training options.
 *
 * Mirrors the backend `simulationOneSchema.training.selectedOptions` whitelist
 * (helpers/routeHelper.js). Shared by every place a course can be selected for
 * a campaign — the web launch wizard and the AI/MCP chat flow — so a course
 * that is selected but never explicitly configured still launches with the
 * same settings everywhere.
 */
export const DEFAULT_COURSE_OPTIONS = {
	isLectureSwitching: false,
	isVideoSeeking: false,
	isSkipQuestions: false,
	isQuizBeforeVideo: false,
	isQuizFailReminder: true,
	isQuizRandomizer: false,
	isUserCorrectAnswer: false,
	isVideoSpeedControls: false,
	isLectureSwitchRestriction: false,
	quizPassingPercentage: 10,
	gamePassingPercentage: 10,
};

/** Build the `selectedOptions` map the launch payload expects. */
export const buildSelectedOptions = (selectedCourses = [], options = {}) => {
	const selectedOptions = {};
	selectedCourses.forEach((courseId) => {
		selectedOptions[courseId] = options[courseId] || { ...DEFAULT_COURSE_OPTIONS };
	});
	return selectedOptions;
};

export default DEFAULT_COURSE_OPTIONS;
